import React, { Component } from "react";
import moment from "moment";
import DateRangePicker from "../Invoice/DateRangePicker";
import { Grid } from "@mui/material";
import Loader from "../../Layout/Loader";
import Scrollbar from "react-scrollbars-custom";
import Button from "../common/Button";
import TextField from "../common/TextField";
import MenuItem from "../common/MenuItem";

let contractTypes = [
  { id: "packages", name: "Packages" },
  { id: "services", name: "Services" },
  { id: "items", name: "Items" },
];

export default class serviceMissingItemsFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: "",
      to: "",
      isVisible: false,
      expenseType: "",
      contractNumber: "",
      accType: "",
    };
  }

  showDates = (e, date) => {
    const adjustedEndDate = date.endDate
      .clone()
      .set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    let timezone = "Asia/Riyadh";
    if (this.props.ServerSetting?.attributes?.timezone) {
      timezone = this.props.ServerSetting.attributes.timezone;
    }
    if (this.props.logInUser?.attributes?.timezone) {
      timezone = this.props.logInUser.attributes.timezone;
    }
    moment.tz.setDefault(timezone);

    var formatedDate = {
      from: moment(date.startDate.format("YYYY-MM-DD HH:mm")).toISOString(),
      to: adjustedEndDate.toISOString(),
    };

    let timeFormat = "HH:mm";
    if (this.props.logInUser && this.props.logInUser.twelveHourFormat) {
      timeFormat = "hh:mm A";
    }

    this.setState({
      selectedDate:
        moment(date.startDate).format("YYYY-MM-DD " + timeFormat) +
        " - " +
        adjustedEndDate.format("YYYY-MM-DD " + timeFormat),
      ...formatedDate,
    });
  };

  handleChange = (name, e) => {
    if (name === "expenseType" || name === "accType") {
      this.setState({
        [name]: e.target.value,
      });
    } else if (name === "clearFilter") {
      this.setState(
        {
          from: "",
          to: "",
          selectedDate: "",
          expenseType: "",
          accType: "",
        },
        () => {
          this.validatedForm();
        }
      );
    } else {
      this.setState({
        contractNumber: e,
      });
    }
  };

  validatedForm = () => {
    this.props.getMissingItems(
      this.state.contractNumber.contractNumber,
      this.state.to,
      this.state.from,
      this.state.expenseType,
      this.state.accType
    );
  };

  render() {
    const viewScreen = (
      <form style={{ padding: "16px 0 16px 10px" }}>
        <Grid container className="form-group sidebar-bg-layer">
          <Grid item xs={12} style={{ padding: 10 }}>
            <h4 style={{ margin: 10 }}>
              {this.props.translate("Out of Contract Items")}:{" "}
              {this.props.selectedAccount.accountName}
            </h4>

            <DateRangePicker
              fill
              error={this.props.timeError || false}
              selectedDate={this.state.selectedDate}
              label={
                this.props.translate("reportFrom") +
                " " +
                this.props.translate("reportTo")
              }
              onEvent={this.showDates}
            />
          </Grid>
          <Grid item xs={12} style={{ padding: 10 }}>
            <TextField
              id="expenseType"
              select
              label={this.props.translate("category")}
              value={this.state.expenseType || ""}
              onChange={(e) => this.handleChange("expenseType", e)}
              margin="dense"
              fullWidth
              required
            >
              {contractTypes.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {this.props.translate(option.name)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <div style={{ display: "flex", justifyContent: "space-between", margin: 20 }}>
              <Button
                onClick={(e) => this.validatedForm("", "", "")}
                style={{ height: "40px", width: "110px" }}
              >
                {this.props.translate("submit")}
              </Button>
              <Button
                style={{ height: "40px", width: "110px" }}
                id="clearFilter"
                onClick={(e) => this.handleChange("clearFilter", e)}
              >
                {this.props.translate("Clear Filters")}
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    );

    return (
      <div className="geofence-sidebar-list">
        {!this.props.loader ? (
          <Scrollbar>{viewScreen}</Scrollbar>
        ) : (
          <Loader component="filter" />
        )}
      </div>
    );
  }
}
